import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  setEnvironmentBasedOnRoute() {
    // apiUrl, currentUrl, ioApplicationUrl and production are now read directly
    // from environment.ts (populated via process.env), so there is nothing left
    // to resolve per-stage here. Kept as a no-op for backwards compatibility
    // with existing callers (e.g. app.component.ts).
    console.log(environment, 'environment');
  }
}
